import { render, staticRenderFns } from "./addCommunityPublicityList.vue?vue&type=template&id=042c7a53&scoped=true"
import script from "./addCommunityPublicityList.vue?vue&type=script&lang=js"
export * from "./addCommunityPublicityList.vue?vue&type=script&lang=js"
import style0 from "./addCommunityPublicityList.vue?vue&type=style&index=0&id=042c7a53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042c7a53",
  null
  
)

export default component.exports